export const scenes = {
    INIT: -1,
    DESCRIPTION: 0,
    PROLOGUE: 1,
    BOARD: 2,
    BANK: 3,
    CASINO: 4,
    HOTEL: 5,
    APART: 6,
    CASTLE: 7
};
export function getSceneName(sceneNumber) {
    if (sceneNumber === scenes.PROLOGUE) {
        return "プロローグ";
    }
    else if (sceneNumber === scenes.BOARD) {
        return "すごろくボード";
    }
    else if (sceneNumber === scenes.BANK) {
        return "銀行";
    }
    else if (sceneNumber === scenes.CASINO) {
        return "カジノ";
    }
    else if (sceneNumber === scenes.HOTEL) {
        return "ホテル";
    }
    else if (sceneNumber === scenes.APART) {
        return "アパート";
    }
    else if (sceneNumber === scenes.CASTLE) {
        return "お城";
    }
    return "??";
}
export const cards = {
    DEFAULT: { name: "DEFAULT", image: "card2", num: 2, used: false },
    SECOND: { name: "SECOND", image: "card2", num: 2, used: false },
    PROLOGUE: { name: "PROLOGUE", image: "さいしょ", num: 2, used: false },
    BANK: { name: "BANK", image: "りんご", num: 2, used: false },
    CASINO: { name: "CASINO", image: "かね", num: 2, used: false },
    HOTEL1: { name: "HOTEL1", image: "すたー", num: 2, used: false },
    HOTEL2: { name: "HOTEL2", image: "はーと", num: 2, used: false },
    HOTEL3: { name: "HOTEL3", image: "おんぷ", num: 2, used: false },
    APART: { name: "APART", image: "まさ", num: 2, used: false },
    CASTLE: { name: "CASTLE", image: "きつつき", num: 6, used: false }
};
